var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1313 14.3111L13.5489 11.8038C13.2918 11.6605 13.0822 11.4449 12.9457 11.1842L10.4384 6.61787C10.3309 6.42221 10.1256 6.30078 9.90233 6.30078C9.67909 6.30078 9.47349 6.42221 9.36627 6.61787L6.85493 11.1842C6.71587 11.439 6.50628 11.6485 6.25148 11.7876L1.66502 14.3112C1.46937 14.4184 1.34766 14.624 1.34766 14.8472C1.34766 15.0705 1.46937 15.2758 1.66502 15.3833L6.25148 17.8906C6.506 18.03 6.7153 18.2393 6.85493 18.4938L9.36227 23.0802C9.46977 23.2759 9.67509 23.3976 9.89804 23.3976C10.1213 23.3976 10.3269 23.2759 10.4344 23.0802L12.9417 18.4938C13.0811 18.2393 13.2901 18.0297 13.5449 17.8906L18.1313 15.3833C18.327 15.2758 18.4487 15.0705 18.4487 14.8472C18.4487 14.624 18.327 14.4184 18.1313 14.3111Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1313 14.3111L13.5489 11.8038C13.2918 11.6605 13.0822 11.4449 12.9457 11.1842L10.4384 6.61787C10.3309 6.42221 10.1256 6.30078 9.90233 6.30078C9.67909 6.30078 9.47349 6.42221 9.36627 6.61787L6.85493 11.1842C6.71587 11.439 6.50628 11.6485 6.25148 11.7876L1.66502 14.3112C1.46937 14.4184 1.34766 14.624 1.34766 14.8472C1.34766 15.0705 1.46937 15.2758 1.66502 15.3833L6.25148 17.8906C6.506 18.03 6.7153 18.2393 6.85493 18.4938L9.36227 23.0802C9.46977 23.2759 9.67509 23.3976 9.89804 23.3976C10.1213 23.3976 10.3269 23.2759 10.4344 23.0802L12.9417 18.4938C13.0811 18.2393 13.2901 18.0297 13.5449 17.8906L18.1313 15.3833C18.327 15.2758 18.4487 15.0705 18.4487 14.8472C18.4487 14.624 18.327 14.4184 18.1313 14.3111Z",
    fill: "url(#paint0_linear_1316_1664)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.321 4.39233L20.1765 3.21813C20.1133 3.18087 20.061 3.12741 20.0257 3.06314L18.8515 0.918647C18.7443 0.722994 18.5387 0.601562 18.3155 0.601562C18.0923 0.601562 17.8867 0.722994 17.7794 0.918647L16.6012 3.06715C16.5645 3.13198 16.5111 3.18573 16.4462 3.22213L14.3017 4.39634C14.1061 4.50383 13.9844 4.70916 13.9844 4.93239C13.9844 5.15563 14.1061 5.36123 14.3017 5.46845L16.4502 6.64265C16.5139 6.67763 16.5663 6.72995 16.6012 6.79365L17.7755 8.93815C17.8829 9.1338 18.0883 9.25523 18.3115 9.25523C18.5347 9.25523 18.7401 9.13352 18.8476 8.93787L20.0218 6.79337C20.057 6.72768 20.1111 6.67422 20.1765 6.63867L22.321 5.4807C22.5251 5.37605 22.6537 5.16589 22.6537 4.93668C22.6537 4.70719 22.5252 4.49698 22.321 4.39233Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.321 4.39233L20.1765 3.21813C20.1133 3.18087 20.061 3.12741 20.0257 3.06314L18.8515 0.918647C18.7443 0.722994 18.5387 0.601562 18.3155 0.601562C18.0923 0.601562 17.8867 0.722994 17.7794 0.918647L16.6012 3.06715C16.5645 3.13198 16.5111 3.18573 16.4462 3.22213L14.3017 4.39634C14.1061 4.50383 13.9844 4.70916 13.9844 4.93239C13.9844 5.15563 14.1061 5.36123 14.3017 5.46845L16.4502 6.64265C16.5139 6.67763 16.5663 6.72995 16.6012 6.79365L17.7755 8.93815C17.8829 9.1338 18.0883 9.25523 18.3115 9.25523C18.5347 9.25523 18.7401 9.13352 18.8476 8.93787L20.0218 6.79337C20.057 6.72768 20.1111 6.67422 20.1765 6.63867L22.321 5.4807C22.5251 5.37605 22.6537 5.16589 22.6537 4.93668C22.6537 4.70719 22.5252 4.49698 22.321 4.39233Z",
    fill: "url(#paint1_linear_1316_1664)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1316_1664",
    x1: 29.5,
    y1: -5,
    x2: 4.18846,
    y2: 18.9334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00796B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#8BC34A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC107"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1316_1664",
    x1: 29.5,
    y1: -5,
    x2: 4.18846,
    y2: 18.9334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00796B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#8BC34A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC107"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanionIcon);
export default __webpack_public_path__ + "static/media/companionIcon.91698a0eb038d8db0a7e14f061e32eb8.svg";
export { ForwardRef as ReactComponent };